import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export interface User {
  id: bigint;
  userId: string;
  email: string;
  name: string;
  roles: string[];
  cuentaActiva?: boolean;
}

interface AuthState {
  isAuthenticated: boolean;
  user: User | null;
  token: string | null;
  tokenExpiracion: string | null;
  requiereCambioContrasena: boolean;
  login: (user: User, token: string, tokenExpiracion: string, requiereCambioContrasena: boolean) => void;
  logout: () => void;
  updateUser: (user: Partial<User>) => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      isAuthenticated: false,
      user: null,
      token: null,
      tokenExpiracion: null,
      requiereCambioContrasena: false,
      login: (user, token, tokenExpiracion, requiereCambioContrasena) => {
        set({
          isAuthenticated: true,
          user,
          token,
          tokenExpiracion,
          requiereCambioContrasena,
        });
      },
      logout: () => {
        set({
          isAuthenticated: false,
          user: null,
          token: null,
          tokenExpiracion: null,
          requiereCambioContrasena: false,
        });
      },
      updateUser: (userData) => {
        set((state) => ({
          user: state.user ? { ...state.user, ...userData } : null,
        }));
      },
    }),
    {
      name: 'auth-storage',
    }
  )
);
